import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import { ROUTE_PATHS, ROUTES, API_BASE_URL } from '../config/constants';
import { search } from '../services/api';
import UserCreationModal from '../assets/js/components/UserCreationModal';
import '../assets/css/BdStyles.css';

const BdHeader = () => {
  const { isLoggedIn, isAdmin, logout } = useAdminAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const currentPage = location.pathname;
    if (searchQuery) {
      navigate(`${currentPage}?search=${searchQuery}`);
    }
  };

  const handleLogin = () => {
    navigate(ROUTE_PATHS.BD_LOGIN);
  };

  const handleLogout = () => {
    alert('Has salido de la edición');
    logout();
  };

  useEffect(() => {
    if (!searchQuery) {
      setSearchResults([]);
      return;
    }

    const performSearch = async () => {
      try {
        const results = await search(searchQuery);
        setSearchResults(results);
      } catch (error) {
        setSearchResults([]);
      }
    };

    const debounceTimer = setTimeout(performSearch, 300);
    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);

  return (
    <div className="bd">
      <header>
        <nav className="navbar navbar-expand-lg navbar-light bdnavbar">
          <Link className="navbar-brand" to={ROUTE_PATHS.BD}>
            <img
              src={`${API_BASE_URL}/public/uploads/images/logo.png`}
              width="180px"
              height="auto"
              alt="Logo"
              loading="eager"
              fetchpriority="high"
            />
          </Link>
          <button
            className="navbar-toggler toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse collapsed" id="navbarNav">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <Link className="nav-link ms-2" to={ROUTE_PATHS.BD_MOVIES}>
                  Películas
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link ms-2" to={ROUTE_PATHS.BD_SERIES}>
                  Series
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link ms-2" to={ROUTE_PATHS.BD_TAGS}>
                  Etiquetas
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link ms-2" to={ROUTE_PATHS.BD_FAVORITES}>
                  Favoritos
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link ms-2" href="mailto:ligaincom@us.es">
                  Contacta
                </a>
              </li>
              <li className="nav-item">
                <div className="d-block ms-auto align-items-center">
                  {!isLoggedIn && (
                    <button
                      className="btn logout-btn"
                      style={{
                        backgroundColor: 'white',
                        border: '2px solid #005EC4',
                        borderRadius: '15px',
                        color: '#005EC4',
                        cursor: 'pointer',
                        padding: '10px',
                        textDecoration: 'none',
                      }}
                      onClick={handleLogin}
                    >
                      Login
                    </button>
                  )}
                </div>
                <div className="d-block ms-auto align-items-center">
                  {isLoggedIn && (
                    <button
                      className="btn logout-btn"
                      style={{
                        backgroundColor: 'white',
                        border: '2px solid #005EC4',
                        borderRadius: '15px',
                        color: '#005EC4',
                        cursor: 'pointer',
                        padding: '10px',
                        textDecoration: 'none',
                      }}
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  )}
                </div>
                {!isLoggedIn && (
                  <div className="d-block ms-auto align-items-right">
                    <button
                      className="btn logout-btn ms-3"
                      style={{
                        backgroundColor: 'white',
                        border: '2px solid #005EC4',
                        borderRadius: '15px',
                        color: '#005EC4',
                        cursor: 'pointer',
                        padding: '10px',
                        textDecoration: 'none',
                      }}
                      onClick={() => setShowUserModal(true)}
                    >
                      Crear Usuario
                    </button>
                  </div>
                )}
              </li>
              {isAdmin && (
                <Link to={ROUTE_PATHS.BD_REQUESTS} replace>
                  <i className="fa fa-bell me-3"></i>
                  {pendingCount > 0 && <span className="badge">{pendingCount}</span>}
                </Link>
              )}
            </ul>
          </div>
        </nav>
        {showUserModal && (
          <UserCreationModal onClose={() => setShowUserModal(false)} />
        )}
      </header>
    </div>
  );
};

export default BdHeader;

